import initialState from './windrowRegistration.state'
export default {
    setApplicantInformation: (state, applicationDetails) => {
        const {name, value} = applicationDetails;
        if(name === "physicallyDisabledStatus" && value === "No") {
            const resetFields = ["applicationType", "familySize", "netIncomeStatus"];
            resetFields.map(field => {
                state.applicantInfo[field] = initialState().applicantInfo[field];
            });
            state.applicantInfo[name] = value || "";
        } else if(name === "familyMemberDisabled" && value === "Yes") {
            const resetFields = ["ageStatus", "physicallyDisabledStatus", "familySize", "netIncomeStatus", "applicationType"];
            resetFields.map(field => {
                state.applicantInfo[field] = initialState().applicantInfo[field];
            });
            state.applicantInfo[name] = value || "";
        }
        else if(name === "ageStatus" && value === "No") {
            const resetFields = ["physicallyDisabledStatus", "familySize", "netIncomeStatus", "applicationType"];
            resetFields.map(field => {
                state.applicantInfo[field] = initialState().applicantInfo[field];
            });
            state.applicantInfo[name] = value || "";
        } else if(name === "ageStatus" &&  value === "Yes") {
            state.applicantInfo.physicallyDisabledStatus = initialState().applicantInfo.physicallyDisabledStatus;
            state.applicantInfo[name] = value || "";
        } else if(name === "applicationType" && value === "Paid program") {
            const resetFields = ["familySize", "netIncomeStatus"];
            resetFields.map(field => {
                state.applicantInfo[field] = initialState().applicantInfo[field];
            });
            state.applicantInfo[name] = value || "";
        } else if(name === "residentStatus" &&  value === "No") {
            state.applicantInfo = initialState().applicantInfo;
            state.applicantInfo[name] = value || "";
        } else if (name === "streetNumber" && value) {
            state.applicantInfo[name] = parseInt(value);
        } else if (name === "postalCode" && value) {
            state.applicantInfo[name] = value.toUpperCase();
        } else if(name === "familySize" && !value) {
            state.applicantInfo.familySize = initialState().applicantInfo.familySize;
        } else {
            state.applicantInfo[name] = value || "";
        }
    },
    setDocumentsInformation: (state, documentsDetail) => {
        state.documentsInfo.incomeProofFileName = documentsDetail?.incomeProofFile?.name;
        state.documentsInfo.ageOrHealthProofFileName = documentsDetail?.ageOrHealthProofFile?.name;
        state.documentsInfo.residenceProofFileName = documentsDetail?.residencyProofFile?.name;
    },
    setErrors: (state, error) => {
        state.errors = { ...state.errors, ...error };
    }
}